import image from '../assets/presentation.png';


const Presentation: React.FC = () => (
    <div className="container-presentation">
        <img src={image} alt="presentation" className="presentation-image" />
        <div className="description">
            <h1 className="title">DXPress</h1>
            <h2 className="subtitle">Este es el panel administrativo de DXPress, su uso está reservado solo a administradores.</h2>
        </div>
    </div>
);

export default Presentation;